"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uid;
var now = +new Date();
var index = 0;

function uid() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'upload';
  index += 1;
  return "".concat(prefix, "-").concat(now, "-").concat(index);
}